
// Cart Add From Card | CAFC
    // CAPITALS = targeted static element
    // starts with '$' = returns html
    
window.CAFC = {
    NOTIFICATION_COMPONENT: document.querySelector('cart-notification'),
    NOTIFICATION_HTML_TARGET: document.getElementById('cart-notification-product-added'),
    CART_BUBBLE: document.getElementById('cart-count-bubble-to-update'),
    
    $input: `
        <div class="cart-add-from-card-quantity-wrapper">
            <div class="loading-overlay__spinner">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>
            <button
                type="button"
                class="cart-add-from-card-minus"
                onclick="CAFC.handleInputBtn(this, -1)"
            >
                <svg viewBox="0 0 24 24" fill="none">
                    <path d="M6 12L18 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <input name="adjust-quanity-in-cart" class="cart-add-from-card-input" type="number" value="1" onkeypress="if(event.key==='Enter') CAFC.handleInput(this)" />
            <button
                type="button"
                class="cart-add-from-card-plus"
                onclick="CAFC.handleInputBtn(this, 1)"
            >
                <svg viewBox="0 0 24 24" fill="none">
                    <path d="M6 12H18M12 6V18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    `,
    $btn: `
        <button 
            type="button"
            class="button button-primary button--add-to-cart-from-card"  
            onclick="CAFC.handleBtn(this)"
        >
            <svg class="button--cart-icon" width="26" height="25" viewBox="0 0 26 25" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.34211 3.59994L2.81252 4.13351L4.20327 8.53518C4.21338 8.56717 4.22529 8.59809 4.23885 8.62786L7.15214 18.2473C7.18066 18.3415 7.22524 18.4275 7.28233 18.5026C6.83744 18.9564 6.56312 19.5781 6.56312 20.2638C6.56312 21.6534 7.68958 22.7798 9.07915 22.7798C10.4687 22.7798 11.5952 21.6534 11.5952 20.2638C11.5952 19.7277 11.4275 19.2308 11.1418 18.8226H18.6948C18.4091 19.2308 18.2414 19.7277 18.2414 20.2638C18.2414 21.6534 19.3679 22.7798 20.7575 22.7798C22.147 22.7798 23.2735 21.6534 23.2735 20.2638C23.2735 19.6064 23.0214 19.0079 22.6085 18.5597C22.6905 18.4702 22.7532 18.3614 22.7888 18.2392L25.9669 7.33379C26.1131 6.83237 25.7535 6.32574 25.232 6.29814L4.85488 5.21967L4.23704 3.26424C4.16113 3.02399 3.97776 2.83273 3.74091 2.74679L1.89478 2.07688C1.4742 1.92427 1.00953 2.1415 0.856913 2.56208C0.704297 2.98266 0.921526 3.44732 1.34211 3.59994ZM21.403 17.2023H8.52832L5.39942 6.87086L24.1251 7.86193L21.403 17.2023ZM9.07824 21.1597C9.57298 21.1597 9.97404 20.7586 9.97404 20.2639C9.97404 19.7692 9.57298 19.3681 9.07824 19.3681C8.58351 19.3681 8.18244 19.7692 8.18244 20.2639C8.18244 20.7586 8.58351 21.1597 9.07824 21.1597ZM20.7566 21.1597C21.2513 21.1597 21.6524 20.7586 21.6524 20.2639C21.6524 19.7692 21.2513 19.3681 20.7566 19.3681C20.2618 19.3681 19.8608 19.7692 19.8608 20.2639C19.8608 20.7586 20.2618 21.1597 20.7566 21.1597Z" fill="#fff"></path>
            </svg>
            
            <div class="loading-overlay__spinner hidden">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>

        </button>    
    `,
    target: {
        title: '',
        img: '',
        id: '',
    },
    setTarget: (el) => {
        const parent = el.closest('.cart-add-from-card-data');
        CAFC.target.title = parent.getAttribute('data-title');
        CAFC.target.img = parent.getAttribute('data-img');
        CAFC.target.id = parent.getAttribute('data-id');
    },
    notificationHtmlUpdate: () => CAFC.NOTIFICATION_HTML_TARGET.innerHTML = `
        <div class="cart-notification-product-added-image" style="background-image: url(${CAFC.target.img})" ></div>
        <p class="cart-notification-product-added-title">${CAFC.target.title}</p>
    `,
    showBtn: (el) => el.closest('.cart-add-from-card-wrapper').innerHTML = CAFC.$btn, 
    showInput: (el) => el.closest('.cart-add-from-card-wrapper').innerHTML = CAFC.$input,  
    updateCartBubble: (quantity) => {
        const currCount = +CAFC.CART_BUBBLE.innerHTML;
        const newCount = currCount + quantity;
        CAFC.CART_BUBBLE.innerHTML = newCount;
        if(currCount === 0 && newCount > 0) {
            CAFC.CART_BUBBLE.closest('.cart-count-bubble').classList.remove('hidden');
        } else if(newCount === 0) {
            CAFC.CART_BUBBLE.closest('.cart-count-bubble').classList.add('hidden');
        }
    },
    updateCartBubbleByAPI: async () => {
        CAFC.CART_BUBBLE.parentElement.classList.add('thinking');

        await fetch (window.location.origin+'/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(res => res.json())
        .then((res) => {
            const newCount = res.item_count;
            CAFC.CART_BUBBLE.innerHTML = newCount;
            CAFC.CART_BUBBLE.parentElement.classList.remove('thinking');
            if(newCount > 0) {
                CAFC.CART_BUBBLE.closest('.cart-count-bubble').classList.remove('hidden');
            } else if(newCount === 0) {
                CAFC.CART_BUBBLE.closest('.cart-count-bubble').classList.add('hidden');
            }
        })
        .catch((err) => {
            // we wont alert the user if there is an error here
            console.log(err)
            // we'll just hide our shame.
            CAFC.CART_BUBBLE.closest('.cart-count-bubble').classList.add('hidden');
        })  
    },
    updateCart: async (totalQuantity, callback) => {
        const updates = {
            [CAFC.target.id]: totalQuantity
        };
        await fetch (window.location.origin+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({updates})
        })
        .then(() => {
            callback();
        })
        .catch((err) => {
            // alert user of an error
            alert('Somthing went wrong & we couldn\'t update your cart');
        })  
    },
    handleInput: (inputElement) => {
        // updates cart with the total value (eg I want 5 in my cart)
        const PARENT_EL = inputElement.parentElement;
        CAFC.setTarget(inputElement);
        // set input to spinner
        inputElement.blur();
        PARENT_EL.classList.add('thinking');
        const newQuantity = +inputElement.value;

        CAFC.updateCart(newQuantity, () => {
            PARENT_EL.classList.remove('thinking');
            // updates the cart 
            document.querySelector('cart-drawer').loadCartDrawerSection();
            // if we need to replace the inputs back to the std btn
            if(newQuantity === 0) CAFC.showBtn(inputElement);
            // Note : we can't guess the new cart total, we use an api to get the value
            CAFC.updateCartBubbleByAPI();
        })
    },
    handleInputBtn: (btnElement, adjustment) => {
        // updates the cart with an adjustment value (eg minus 1 off the current total)
        const PARENT_EL = btnElement.parentElement;
        const INPUT_EL = PARENT_EL.querySelector('input');
        CAFC.setTarget(btnElement);
        // set input to spinner
        PARENT_EL.classList.add('thinking');
        const currQuantity = +INPUT_EL.value;
        const newQuantity = currQuantity + adjustment;

        CAFC.updateCart(newQuantity, () => {
            PARENT_EL.classList.remove('thinking');
            // display the new value in the input
            INPUT_EL.value = newQuantity;
            // update the cart-bubble
            CAFC.updateCartBubble(adjustment);
            // updates the cart 
            document.querySelector('cart-drawer').loadCartDrawerSection();
            // if we need to replace the inputs back to the std btn
            if(newQuantity === 0) CAFC.showBtn(btnElement);
        })

    },
    handleBtn: (btnElement) => {
        CAFC.setTarget(btnElement);
        
        // update the notification bar html (before it is displayed)
        CAFC.notificationHtmlUpdate();

        btnElement.classList.add('button--thinking');
        // window.customElements.cart_type = 'notification';

        CAFC.updateCart(1, () => {
            // no more thinking state
            btnElement.classList.remove('button--thinking');
            // show notification
            CAFC.NOTIFICATION_COMPONENT.open();
            // update the cart-bubble
            CAFC.updateCartBubble(1);
            // updates the cart 
            document.querySelector('cart-drawer').loadCartDrawerSection();
            // remove the button and replace with inputs
            CAFC.showInput(btnElement, 1);
        });
    },
    handleCartHasChanged: (cartItems) => {
        // when the cart is updated, we need to match the cards

        // we need to loop through all cards on the pages
        // (rather than looping through all cart items because something may have been removed)
        document.querySelectorAll('.cart-add-from-card-data').forEach(card => {
            const cardID = card.getAttribute('data-id');
            const cartItem = cartItems.find(item => item.id == cardID);
            const cartQty = cartItem ? cartItem.quantity : 0;
            const targetInput = card.querySelector('.cart-add-from-card-input');
            // if this is not in the cart, and there is no targetInput then we can continue
            if(!cartItem && !targetInput) return;
            if(!cartItem && targetInput) {
                // if it's no longer in the cart, replace the input with the button
                CAFC.showBtn(targetInput);
            } else if(cartQty > 0 && !targetInput) {
                // if it's in the cart, and there is no input, replace the button with an input
                CAFC.showInput(card.querySelector('.button'));
                // we might need to update the value?
                if(cartQty !== 1) card.querySelector('.cart-add-from-card-input').value = cartQty;
            } else if(cartQty !== +targetInput.value){
                // if it's in the cart and the values do not match
                targetInput.value = cartQty;
            }
        })

    }
}
